import { ExternalLink, ShieldCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Public button shown on a business profile when the company has an
 * approved external website link. Renders nothing if the backend did
 * not include the `external_website` payload (plan + admin gating
 * already happened server-side).
 */
export function ExternalWebsiteButton({ companyId, externalWebsite,
                                          className = "",
                                          placement = "profile_website_cta" }) {
  if (!externalWebsite || !externalWebsite.url) return null;
  const { url, button_label, verified } = externalWebsite;
  const onClick = () => {
    // Fire-and-forget click counter.
    try {
      navigator.sendBeacon
        ? navigator.sendBeacon(
            `${API}/public/business/${encodeURIComponent(companyId)}/external-website/click`,
            new Blob([JSON.stringify({ placement })], { type: "application/json" }),
          )
        : fetch(`${API}/public/business/${encodeURIComponent(companyId)}/external-website/click`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ placement }),
            keepalive: true,
          });
    } catch {}
  };

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        data-testid="public-external-website-button"
        className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-[#1B4332] text-white text-sm font-semibold hover:bg-emerald-800 transition"
      >
        {button_label || "Visit official website"}
        <ExternalLink className="w-3.5 h-3.5 opacity-80" />
      </a>
      {verified && (
        <div className="inline-flex items-center gap-1 text-[11px] text-emerald-700"
             data-testid="public-external-website-verified">
          <ShieldCheck className="w-3 h-3" /> Website ownership verified
        </div>
      )}
      <p className="text-[10px] text-slate-500 italic max-w-sm">
        This link opens the business’s own website. ConfirmPh does not
        control external website content.
      </p>
    </div>
  );
}

export default ExternalWebsiteButton;
